module.exports = __webpack_public_path__ + "static/media/8.9594ed9d.svg";